export default __webpack_public_path__ + "static/AseoInd_1-c4282a390383cf47d8a7556dd8f031b7.png";